// Bypass CRA's Babel loaders and emit the prebuilt worker unchanged.
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapWorkerUrl from "!!file-loader?esModule=false&name=static/media/maplibre-worker.[contenthash:8].js!maplibre-gl/dist/maplibre-gl-csp-worker.js";

export default mapWorkerUrl;
